import React, { useMemo } from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardSharedTable from '@components/pages/Dashboard/Shared/DashboardSharedTable'
import type { RangeKey } from '@dataTypes/dashboard.types'
import type { IncompleteTreatmentOverviewResult } from '@services/api/dashboard/treatment.api'
import { isDashboardDevMocksEnabled } from '@utils/dashboardDevMocks.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import {
  getIncompleteTreatmentPlanData,
  INCOMPLETE_TREATMENT_PLAN_COLUMNS,
} from '../dashboardOverview.mockData'
import { renderOverviewTableActionsCell } from './overviewTableActions'

type IncompleteTreatmentPlanCardProps = {
  range: RangeKey
  data: IncompleteTreatmentOverviewResult | null
  loading: boolean
}

export function IncompleteTreatmentPlanCard({
  range,
  data,
  loading,
}: IncompleteTreatmentPlanCardProps): React.ReactElement {
  const useMocks = isDashboardDevMocksEnabled()
  const rows = useMemo(() => {
    if (data != null) return data.rows ?? []
    return useMocks ? getIncompleteTreatmentPlanData(range) : []
  }, [data, range, useMocks])
  const isEmpty = shouldShowDashboardSectionEmpty(loading, rows.length > 0)
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Incomplete treatment plan"
      titleHref="/dashboard/incomplete-treatment-plan"
      className="dashboard-treatment-tables-card"
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
    >
      <DashboardSharedTable
        loading={pending ? false : loading}
        showSearchFilter={false}
        columns={INCOMPLETE_TREATMENT_PLAN_COLUMNS.map((col) =>
          col.key === 'actions'
            ? { ...col, formatter: renderOverviewTableActionsCell }
            : col,
        )}
        data={rows}
        showPagination={false}
      />
    </DashboardSectionCard>
  )
}
